import { Component } from '@angular/core';
import { courses } from '../../../providers/static-data';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CourseApiServiceService } from '../course-api-service.service';
import { PaginationComponent } from "../../../components/pagination/pagination.component";
import { LoaderComponent } from "../../../providers/loader.component";
import { finalize } from 'rxjs';
import { FilterBaseAccessService } from '../../../auth/filterbase-access';

@Component({
  selector: 'app-courses-list',
  standalone: true,
  imports: [RouterModule, CommonModule, PaginationComponent, LoaderComponent],
  templateUrl: './courses-list.component.html',
  styleUrl: './courses-list.component.css'
})
export class CoursesListComponent {
  islistaccess:boolean=true;
  data = courses
  currentTab = 'all'
  isFetching:boolean = false;
  tabs = [
    { name: 'All', value: 'all' },
    { name: 'Video Courses', value: 'video' },
    { name: 'Flashcard Courses', value: 'flashcard' },
    { name: 'Test Series', value: 'test' },
    { name: 'Conclave', value: 'conclave' },
  ]

  courses: any[] = []
  coursesClone: any[] = []

  paginationData: any = {}
  currentPage: any

  constructor(access:FilterBaseAccessService, private courseApiService: CourseApiServiceService) {
    this.islistaccess=access.checkaccessforfiltersandactions("course list");
   }

  ngOnInit(): void {
    this.getData()
  }

  getData() {
  this.isFetching = true;

  this.courseApiService.getAllCourses(this.currentPage, this.currentTab)
    .pipe(finalize(() => {
      this.isFetching = false;
    }))
    .subscribe({
      next: (res: any) => {
        if (res.status === 'success') {
          this.courses = res.data;
          this.coursesClone = res.data;
          this.paginationData = res?.pagination ?? {};
        } else {
          // API returned fail status
          this.courses = [];
          this.coursesClone = [];
          this.paginationData = [] ;
        }
      },
      error: (err) => {
        console.error('HTTP error:', err);
      }
    });
}

  isValidCoursetpe(value: unknown): boolean {
    return typeof value === 'string' && value.trim() !== '';
  }


  changeTab(tab: string) {
    this.currentTab = tab;
    // Reset pagination when switching filter/tab
    this.currentPage = 1;
    this.getData();
  }

  pageChange(e: any) {
    this.currentPage = e;
    this.getData();
  }


}
